import { render, staticRenderFns } from "./CtaButton.vue?vue&type=template&id=027f1e3c&scoped=true&"
import script from "./CtaButton.vue?vue&type=script&lang=ts&"
export * from "./CtaButton.vue?vue&type=script&lang=ts&"
import style0 from "./CtaButton.vue?vue&type=style&index=0&id=027f1e3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f1e3c",
  null
  
)

export default component.exports